import type { ProjectAd } from '../../type';
import { useAppDisplayModeContext, useStyles } from '@archipro-design/aria';
import AdvertMediumRectangle from '../advert-medium-rectangle/AdvertMediumRectangle';
import AdvertBillboard from '../advert-billboard/AdvertBillboard';
import * as S from './AdvertProjectPlacementTile.style';

interface AdvertProjectPlacementTileProp {
    ad: ProjectAd;
    columns: number;
}

export const AdvertProjectPlacementTile = (
    props: AdvertProjectPlacementTileProp
) => {
    const { ad, columns } = props;
    const appDisplayMode = useAppDisplayModeContext();
    const { mobile: isMobile } = appDisplayMode;
    const { css } = useStyles({ columns });

    let adTile = null;
    if (isMobile) {
        adTile = (
            <AdvertMediumRectangle
                title={ad.title}
                carousel={ad.carousel}
                advertCreative={ad.advertCreative}
            />
        );
    } else {
        adTile = (
            <AdvertBillboard
                title={ad.title}
                carousel={ad.carousel}
                advertCreative={ad.advertCreative}
            />
        );
    }

    return <div className={css(S.ProjectPlacementContainer)}>{adTile}</div>;
};
